import axios from "axios";
import Sortable from "sortablejs";

Array.from(document.querySelectorAll('.form-media-items')).forEach(function(container) {

    let mediaInput = container.parentElement.querySelector('[type="hidden"]');
    let addButton = container.querySelector('.form-media-item-add');

    new Sortable(container, {
        sort: true,
        draggable: ".form-media-item",
        onChange: function () {
            let addButton = document.querySelector('.form-media-item-add');
            addButton.parentNode.appendChild(addButton);
        },
        onEnd: function() {
            serializeImages(mediaInput);
        }
    });

    addButton.addEventListener('dragenter', preventDefault, false);
    addButton.addEventListener('dragleave', preventDefault, false);
    addButton.addEventListener('dragover', preventDefault, false);
    addButton.addEventListener('drop', preventDefault, false);

    addButton.addEventListener('dragenter', handleDragEnter, false);
    addButton.addEventListener('dragleave', handleDragLeave, false);
    addButton.addEventListener('dragover', handleDragOver, false);
    addButton.addEventListener('drop', handleDrop, false);

    if (addButton) {

        addButton.onclick = function() {

            let inputElement = document.createElement('input');
            inputElement.setAttribute('type', 'file');
            inputElement.setAttribute('style', 'display: none!important;');
            inputElement.setAttribute('accept', 'image/png, image/gif, image/jpeg, application/pdf');
            inputElement.setAttribute('multiple','multiple');

            document.body.appendChild(inputElement);

            inputElement.onchange = function() {

                let filesToUpload = inputElement.files.length;
                let uploadedFiles = 0;
                
                Array.from(inputElement.files).forEach(function(file) {

                    let formData = new FormData();

                    formData.append('file', file);
                    axios.post('/file', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(function(response) {
                        console.log(response);
    
                        let data = response.data.data;
    
                        addImageTo(data, container);
                        serializeImages(mediaInput);
    
                    }).catch(function(error) {
                        console.error(error);
                        console.log(error.response);
                        alert(error.response.data.message);
                    }).then(function() {
                        uploadedFiles++;
                        if (uploadedFiles >= filesToUpload) {
                            inputElement.remove();
                        }
                        console.log("done upload");
                    });

                });

            }

            inputElement.click();

            return false;
        }

    }

    container.onclick = function(e) {
        let removeButton = e.target ? e.target.closest('.form-media-item-remove') : false;
        if (removeButton) {

            let mediaElm = removeButton.closest('[data-image-url]');
            if (mediaElm) {
                let media_hash = mediaElm.getAttribute('data-media-hash');

                axios.delete('/file', {
                    data: {
                        hash: media_hash
                    }
                });

                mediaElm.remove();
                serializeImages(mediaInput);
            }

        }

    }

});

function handleDrop(e) {

    let data = e.dataTransfer;
    let files = data.files;

    let wrapper = this.closest('.form-media-items');

    var mediaInput = wrapper.parentElement.querySelector('[type="hidden"]');

    Array.from(files).forEach(function(file) {

        let formData = new FormData();

        formData.append('file', file);
        axios.post('/admin/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function(response) {
            console.log(response);

            let data = response.data.data;

            addImageTo(data, wrapper);
            serializeImages(mediaInput);

        }).catch(function(error) {
            console.error(error);
            console.log(error.resposne);
        }).then(function() {
            console.log("done upload");
        });

    });

    this.classList.remove('drag--enter');
    this.classList.remove('drag--over');
}


function addImageTo(data, wrapper) {

    let mediaElm = document.createElement('div');
    mediaElm.className = 'form-media-item';
    mediaElm.setAttribute('data-image-url', data.url);
    mediaElm.setAttribute('data-media-hash', data.hash);
    mediaElm.setAttribute('data-media-id', data.id);
    mediaElm.innerHTML = `<div class="form-media-item-overlay ">
            <button type="button" class="form-media-item-remove button button--transparent"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg></button>
        </div>
        <div class="form-media-item-content">
            <img src="${data.url}">
        </div>`;

    wrapper.insertBefore(mediaElm, wrapper.lastElementChild);
}

function serializeImages(input) {

    let mediaList = Array.from(input.parentElement.querySelectorAll('[data-media-id]')).map(function(elm) {
        return elm.getAttribute('data-media-id');
    });

    input.value = mediaList.join(',');

    input.parentElement.querySelector('.form-media-items').classList.toggle('form-media-items--has-image', mediaList.length != 0);
}

function preventDefault(e) {
    e.preventDefault();
    e.stopPropagation();
}

function handleDragEnter(e) {
    this.classList.add('drag--enter');
}

function handleDragLeave(e) {
    this.classList.remove('drag--enter');
    this.classList.remove('drag--over');
}

function handleDragOver(e) {
    this.classList.add('drag--over');
}